import React, { FC, MouseEvent, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Modal } from 'antd';

// Shared UI Library Components
import { CustomButton } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './delete-session-modal.scss';

// Store entities
import { deleteStoreSessionAttributes } from '../../store/session-settings/session-settings.thunks';

// Models
import { TSessionType } from '../../types/settings.types';

type TDeleteSessionModalProps = {
  open: boolean;
  session_type?: TSessionType;
  sessionId?: number;
  onCancel?: () => void;
}

export const DeleteSessionModal: FC<TDeleteSessionModalProps> = (
  { open = false, session_type, sessionId, onCancel = () => {} }: TDeleteSessionModalProps
) => {
  const [savingChanges, setSavingChanges] = useState<boolean>(false);

  const dispatch = useDispatch<any>();

  const handleCancel = (_: MouseEvent<HTMLButtonElement>): void => {
    onCancel();
  };

  const handleSubmit = async (): Promise<void> => {
    if (!sessionId || !session_type) return;
    setSavingChanges(true);

    const { payload } = await dispatch(deleteStoreSessionAttributes({
      id: sessionId,
      session_type
    }));

    setSavingChanges(false);
    if (!payload) return;
    onCancel();
  }

  return (
    <Modal
      rootClassName="delete-session-modal"
      width={ '395px' }
      open={ open }
      centered={ true }
      closeIcon={ false }
      title={ 'Are you sure you want to delete Session?' }
      footer={ [
        <CustomButton key="no" text={ 'No' } type={ 'text' } onClick={ handleCancel }/>,
        <CustomButton key="yes" text={ 'Yes' } loading={ savingChanges } onClick={ handleSubmit }/>
      ] }
      onCancel={ handleCancel }
    />
  )
};
